import { render, staticRenderFns } from "./ListingFormsForApprovals.vue?vue&type=template&id=0728f9ff"
import script from "./ListingFormsForApprovals.vue?vue&type=script&lang=js"
export * from "./ListingFormsForApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports